import { useEffect, useState, useCallback } from "react";

const Toggle = ({
    css = "",
    id,
    defaultState = false,
    onChange = () => { },
    disabled = false
}) => {
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        setChecked(defaultState);
    }, [defaultState]);

    const handleChange = useCallback((id) => {
        setChecked(checked => !checked);
        onChange(id);
    }, [onChange]);

    return (
        <input
            className={`form-check-input ${css}`}
            type="checkbox"
            id={id}
            checked={checked}
            onChange={() => handleChange(id)}
            disabled={disabled} />
    )
};

export default Toggle;